<template>
  <div class="login-wrap">
    <div class="main">
			<div class="logo">
				<img src="../../assets/images/sbklogo1.png" alt="">
			</div>
			<div class="title">
				<img src="../../assets/images/sbktext1.png" alt="">
			</div>
			<h2 v-if="hospitalCode=='SD_LY1'">临沂市中心医院</h2>
			<div class="txtbox user">
				<el-input placeholder="用户名" prefix-icon="icon-user" maxlength="20" v-model="form.username" @keyup.enter.native="login"></el-input>
			</div>
			<div class="txtbox pwd">
				<el-input type="password" placeholder="密码" prefix-icon="icon-lock" maxlength="20" v-model="form.password" @keyup.enter.native="login"></el-input>
			</div>
			<div class="txtbox captcha" v-if="this.hospitalCode == 'AH_FY1'">
				<el-input class= "captcha"	placeholder="验证码" prefix-icon="el-icon-key" maxlength="5" v-model="form.code" @keyup.enter.native="login">
					<img :src="this.captchaSrc" @click="getCaptcha" slot="append">
				</el-input>
			</div>
			<div class="btn">
				<el-button type="primary" @click="login">登录</el-button>
			</div>
			<div class="forgot">
				<!-- <div style="color: #699CE4; cursor:pointer" @click="showClear=true;">清理缓存&gt;</div> -->
				<el-link :underline="false" @click="getPassword">忘记密码？</el-link>
			</div>
			<div class="recom">推荐使用先进浏览器获得最佳体验</div>
			<div class="download" style="display: flex;justify-content:space-between">
				<div class="jisu"><a class="noline" href="360.exe" target="_blank">360极速浏览器</a></div>
				<div class="chrome"><a class="noline" href="chrome.exe" target="_blank">Chrome浏览器</a></div>
				<div class="ubox" v-if="this.UboxCallFlag">
					<a class="noline" href="ubox.zip" target="_blank">双佰康呼叫软件</a></div>
				</div>
			</div>
		<el-dialog custom-class="relative" title="修改密码" width="500px" center :visible.sync="changePwdDlg.active" :close-on-click-modal="false">
			<el-form ref="form" size="small" label-width="80px" :rules="changePwdDlg.rules" :model="changePwdDlg.form">
				<el-form-item label="密码" prop="newPwd">
					<el-input type="password" placeholder="密码" autocomplete="off" v-model="changePwdDlg.form.newPwd"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="repeat">
					<el-input type="password" placeholder="确认密码" autocomplete="off" v-model="changePwdDlg.form.repeat"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="dialog-button" type="primary" size="mini" round :loading="isLoading" @click="saveForm">保存</el-button>
			</div>
		</el-dialog>
		<ClearCache v-if="showClear"/>
  </div>
</template>

<script>
import api from '@/service/api';
import dayjs from 'dayjs';
import utils from '@/service/utils.js';
import ClearCache from '@/components/ClearCache/index.vue'

export default {
	components: {
		ClearCache
	},
	data(){
		let validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.changePwdDlg.form.newPwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
				if (regex.test(value)) {
					callback();
				} else {
					callback(new Error('密码必须包含大小写字母、符号和数字，且长度至少为8个字符'));
				}
			}
		};
		return {
			isLoading: false,
			captchaSrc:'',
			form: {username: '', password: ''},
			hospitalCode:'YS_HM4',
			UboxCallFlag:false,
			changePwdDlg:{
				active:false,
				rules:{
					newPwd: {required: true, message: '请输入', trigger: 'blur'},
					repeat: {required: true, validator: validatePass, trigger: 'blur'},
				},
				form:{
					newPwd:'',
					repeat:'',
					auth:''
				}
			},
			showClear:false,
		}
	},
	async created(){
		api.getHospitalCode().then((res)=>{
			if(res == 'AH_FY1'){
				//阜阳-登录增加验证码
				this.getCaptcha();
			}
			this.hospitalCode = res
		})
		this.UboxCallFlag=await api.getUboxCallFlag();

	},
	methods: {
		async login() {
			let query = this.$route.query;
			if (this.form.username.trim() == '' || this.form.password.trim() == '') {
				return this.$message.warning('请输入账号');
			}
			
			if (this.hospitalCode == 'AH_FY1') {
				//阜阳-登录必填验证码
				if(this.form.code){
					if(this.form.code.trim() == ""){
						this.form.code = "";
						return this.$message.warning('请输入验证码');
					}
				}else{
					return this.$message.warning('请输入验证码');
				}
			}
			this.isLoading = true;
			// let res = await api.login(this.form);
			console.log(utils.rsaEncrypt(this.form.username))
			let params={
				username:utils.rsaEncrypt(this.form.username),
				password:utils.rsaEncrypt(this.form.password),
				...(this.hospitalCode == 'AH_FY1' && {code:this.form.code,key:this.form.key})
			}
			let res = await api.login(params);
			
			if(res.code == 1032){
				// 如果是默认密码，则需要修改密码
				this.$message.error(res.message);
				this.changePwdDlg.form.auth = res.data;
				this.isLoading = false;
				this.changePwdDlg.active = true;
				this.form.username='';
				this.form.password='';
				return;
			}
			
			
			if (res.code != 1000) {
				this.$message.error(res.message);
				if(this.hospitalCode == 'AH_FY1'){
					//阜阳-登录失败刷新验证码
					this.getCaptcha();
					this.form.code = "";
				}
				this.isLoading = false;
				return;
			}
			let user = {data: res.data, expire: +dayjs().add(7, 'day')};
			localStorage.setItem('user', JSON.stringify(user));
			localStorage.setItem('hospitalCode', JSON.stringify(this.hospitalCode));
			this.isLoading = false;
			if (query && query.r) {
				location = query.r;
			} else {
				this.$router.push({ name: 'Home' });	
			}
		},
		getPassword() {
			this.$alert('请联系管理员重置密码',{
				confirmButtonText: '知道了',
				title: '系统提示',
			});
		},
		async getCaptcha(){
			let res = await api.getCaptcha()
			if(res.code == 1000){
				this.captchaSrc = res.data.image;
				this.form.key = res.data.key;
			}
		},
		saveForm() {
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					let res = await api.changeDefaultPwd(this.changePwdDlg.form);
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功,请使用新密码登录');
					this.isLoading = false;
					this.closeDlg();
				}
			});	
		},
		closeDlg(){
			this.$refs['form'].resetFields();
			this.changePwdDlg.active = false;
		},
		clearCache(){
			const ua = navigator.userAgent;

			// 判断是否是 Chrome
			const isChrome = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor);
			console.log(isChrome,'====isChrome')
			if (isChrome) {
				window.open('chrome://settings/clearBrowserData','_blank')
			}

			// 检测是否为 360 浏览器（特征是插件）
			const plugins = window.navigator.plugins;

			for (let i = 0; i < plugins.length; i++) {
			if (plugins[i].name.includes('360')) {
				return '360极速浏览器';
			}
			}
		}
	}
}
</script>

<style lang="less">
@import '@/assets/style/var';

body {background-color: rgba(246,246,246,1);}
.login-wrap {
	position: relative;
	width: 100vw;
	height: 100vh;
	.main {
		position: absolute;
		top: 48%;
		left: 50%;
		width: 500px;
		text-align: center;
		transform: translate3d(-50%, -50%, 0);
		.logo{
			img{
				width: 100px;
				height: 100px;
			}
		}
		.title{
			img{
				width: 332px;
				height: 36px;
				margin-top: 30px;
			}
		}
	}
	.txtbox {
		margin-bottom: 40px;
		margin-top: 42px;
		.el-input__inner { 
			height: 52px;
			line-height: 52px;
			padding-left: 30px;
			font-size: 18px;
		}
		i.el-input__icon {
			top: 2px;
			left: 3px;
			font-size: 18px;
		}
	}
	.el-button--primary {
		width: 100%;
		height: 52px;
		font-size: 24px;
		font-weight: 200;
	}
	.forgot {
		margin: 5px 0 10px;
		display: flex;
		justify-content: end;
	}
	.recom {margin-bottom: 20px; color: #CCC; font-size: 18px;}
	.chrome,.jisu,.ubox{
		a{
			margin: auto;
			padding-left: 26px;
			padding-bottom: 20px;
			background: url('../../assets/images/chrome.png?v=@{v}') no-repeat;
			font-size: 16px;
			display: inline-block;
		}
	}
	.chrome {
		a {
			background: url('../../assets/images/chrome.png?v=@{v}') no-repeat;
		}		
	}
	.jisu {
		a {
			background: url('../../assets/images/360.png?v=@{v}') no-repeat;
		}		
	}
	.ubox{
		a {
			margin-left: 2px;
			background: url('../../assets/images/ubox.png?v=@{v}') no-repeat;
		}
	}
	.captcha .el-input-group__append {
		background-color: #fff;
		img{
			height: 2.75rem;
		}
	}
	
	.dialog-button{
		width: 30%;
		height: 40%;
		display: inline-block;
		line-height: 1;
		white-space: nowrap;
		cursor: pointer;
		-webkit-appearance: none;
		text-align: center;
		box-sizing: border-box;
		outline: 0;
		margin: 0;
		transition: .1s;
		font-weight: 500;
		font-size: 14px;
		border-radius: 4px
	}
}
</style>